// Campus photo for /colleges/missouri-university-of-science-and-technology: CC BY-SA 4.0, by Steveewatkins, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AHavener_Student_Center_at_Missouri_S%26T.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/missouri-university-of-science-and-technology/; credited under the photo.
const photo = {
    "slug": "missouri-university-of-science-and-technology",
    "alt": "The Havener Center and its lawn on the Missouri S&T campus in Rolla, Missouri",
    "src": "/colleges/missouri-university-of-science-and-technology/campus-1600.webp",
    "srcSmall": "/colleges/missouri-university-of-science-and-technology/campus-800.webp",
    "srcMid": "/colleges/missouri-university-of-science-and-technology/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/missouri-university-of-science-and-technology/og.jpg",
    "title": "Havener Student Center at Missouri S&T",
    "author": "Steveewatkins",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AHavener_Student_Center_at_Missouri_S%26T.jpg",
    "read": "2026-10-02"
};

export default photo;
